var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 342",
    style: {
      enableBackground: "new 0 0 1080 342"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M415,206.2H299.5l-15.8,37.3h-61.3L324.8,4.1h64.4L492,243.6h-61.6L415,206.2z M394.9,159l-37.3-89.4l-38,89.4 H394.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M739.1,123.4c0,69.7-51.8,120.1-126.4,120.1h-106V4.4l106-0.4C691.6,3.7,739.1,54.4,739.1,123.4z M564.5,190 h48.2c40.1,0,68-26.4,68-66.6c0-43-27.1-65.8-68-65.8h-48.2V190z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M811.5,243.5h-57.8V4.1h57.8V243.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M830.3,205.5l80.3-79.2L826.1,41l41.2-41.2L951.8,85l87-85.2l41.2,40.8L992.3,127l79.9,79.6l-41.9,41.6 l-78.9-80.3l-79.9,79.6L830.3,205.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.5,171.3c25.7-13.7,42.6-43,42.6-77.5c0-52.1-36.6-89.8-85.2-89.8H0v337.4l57.8-100V184H100l35.9,59.5 h71.8L158.5,171.3z M107.4,130.5H57.8V57.6h50c19.4,0,35.2,16.6,35.2,36.3C143,113.9,127.1,130.5,107.4,130.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadix);
export default __webpack_public_path__ + "static/media/Radix.7bb33fcaf70c7485e59b5814641c8ab4.svg";
export { ForwardRef as ReactComponent };